export const customerFields = /* GraphQL */ `
    __typename
    firstname
    lastname
    customer_id
    suffix
    title
    email
    is_subscribed
    subscription_channels
    date_of_birth
    yotpo_identification {
      identity
      token
      tags
    }
    veratad_info {
      age_verification_override
      is_ageverified
    }
    addresses {
        id
        firstname
        lastname
        street
        city
        county
        region {
            region_id
            region_code
            region
        }
        postcode
        country_code
        telephone
        default_shipping
        default_billing
    }
`
